module.exports = __webpack_public_path__ + "static/banner-contato-5f43b1b7201948b3a70741001674aedf.jpg";